import * as React from 'react';
import { IconSizes, ClockIcon } from '@newcore/icons';
import { Text } from '@newcore/ui/typography';
import { OnboardingStatusCard } from './onboarding-status-card';

export function OnboardingPageExpired(): React.ReactElement {
  return (
    <OnboardingStatusCard
      title='Invitation Expired'
      description='This invitation link has expired'
    >
      <ClockIcon size={IconSizes.XL} className='size-16 text-tertiary' />
      <Text as='p' className='text-tertiary text-center'>
        Please contact your administrator to request a new invitation.
      </Text>
    </OnboardingStatusCard>
  );
}
